const STORAGE_KEY = 'meta_test_event_code'
const TEST_EVENT_CODE_MODES: ReadonlySet<string> = new Set(['staging'])

/** In a `TEST_EVENT_CODE_MODES` build, reads `?meta_test_event_code=` once and keeps it in sessionStorage across
 * navigation and Paddle redirects; returns '' in any other build or when none is active. */
export const getMetaTestEventCode = (mode: string): string => {
  if (!TEST_EVENT_CODE_MODES.has(mode)) return ''
  try {
    const fromUrl = new URLSearchParams(window.location.search).get(STORAGE_KEY)
    if (fromUrl) sessionStorage.setItem(STORAGE_KEY, fromUrl)
    return sessionStorage.getItem(STORAGE_KEY) ?? ''
  } catch {
    return ''
  }
}
